/**
 * Theme Utility Functions
 * 
 * Provides theme management utilities including localStorage persistence
 * and theme-aware style generators.
 */

/**
 * Theme storage key
 */
export const THEME_STORAGE_KEY = 'theme';

/**
 * Default theme
 */
export const DEFAULT_THEME = 'dark';

/**
 * Valid theme values
 */
export const THEMES = {
  DARK: 'dark',
  LIGHT: 'light',
};

/**
 * Gets the current theme from localStorage or returns default
 * 
 * @returns {string} Current theme ('dark' or 'light')
 */
export const getTheme = () => {
  if (typeof window === 'undefined') return DEFAULT_THEME;
  return localStorage.getItem(THEME_STORAGE_KEY) || DEFAULT_THEME;
};

/**
 * Saves theme to localStorage
 * 
 * @param {string} theme - Theme to save ('dark' or 'light')
 */
export const saveTheme = (theme) => {
  if (typeof window === 'undefined') return;
  localStorage.setItem(THEME_STORAGE_KEY, theme);
};

/**
 * Toggles between dark and light theme
 * 
 * @param {string} currentTheme - Current theme
 * @returns {string} New theme
 */
export const toggleTheme = (currentTheme) => {
  const newTheme = currentTheme === THEMES.DARK ? THEMES.LIGHT : THEMES.DARK;
  saveTheme(newTheme);
  return newTheme;
};

